import { state } from '../map_state/state'
import { Renderer } from '../renderer'
import { callMethodOnKeydown, screenCssToWorld, isTyping } from '../helpers'
import { viewport } from '../map_state/viewport'
import { panTool } from './pan_tool'
import { cropTool } from './crop_tool'
import { linearFlowTool } from './linear_flow_tool'
import { dragTool } from './drag_tool'
import { pathTracerTool } from './path_tracer_tool'
import { historyTool } from './history_tool'

class PointDistanceTool {
  constructor () {
    this.element = document.getElementById('mct-point-distance')
    this.keys = {
      Escape: 'Remove all segments',
      Backspace: 'Remove last placed solo point / segment'
    }
    this.toggleVisibility()
    this.bindEvents()
  }

  bindEvents () {
    this.onKeyDown = this.onKeyDown.bind(this)
    this.activate = this.activate.bind(this)
    this.onClick = this.onClick.bind(this)
    this.onBackspace = this.onBackspace.bind(this)
    this.onEscape = this.onEscape.bind(this)
    this.element.addEventListener('click', this.activate)
    document.addEventListener('keydown', this.onKeyDown)
  }

  unBindEvents () {
    this.element.removeEventListener('click', this.activate)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  onKeyDown (e) {
    if (isTyping(e.target)) return
    if (e.key === 'p' && !this.element.classList.contains('hidden')) callMethodOnKeydown(e.target, this.activate)
    if (e.key === 'Escape' && state.pointDistanceMode) {
      e.preventDefault()
      this.onEscape()
    }
    if (e.key === 'Backspace' && state.pointDistanceMode) {
      e.preventDefault()
      this.onBackspace()
    }
  }

  activate (mode = true) {
    if (!state.lenPath) return

    this.active = !state.pointDistanceMode && mode
    if (this.active) {
      if (state.panMode) panTool.activate(false)
      else if (state.cropMode) cropTool.activate(false)
      else if (state.dragMode) dragTool.activate(false)
      else if (state.linearFlowMode) linearFlowTool.activate(false)
      else if (state.tracerMode) pathTracerTool.enableMode(state.tracerMode, false)
      this.element.classList.add('selected')
      state.pointDistanceMode = true
      viewport.canvas.addEventListener('click', this.onClick)
      viewport.canvas.addEventListener('pointermove', this.onPointerMove)
    } else {
      state.pointDistanceMode = false
      this.element.classList.remove('selected')
      viewport.canvas.removeEventListener('click', this.onClick)
      viewport.canvas.removeEventListener('pointermove', this.onPointerMove)
    }

    Renderer.render()
  }

  onClick (e) {
    if (!state.pointDistanceMode) return

    const rect = viewport.canvas.getBoundingClientRect()
    const world = screenCssToWorld({ x: e.clientX - rect.left, y: e.clientY - rect.top })

    const aabb = {
      left: state.mapWorld.x,
      top: state.mapWorld.y,
      right: state.mapWorld.x + state.mapImage.naturalWidth,
      bottom: state.mapWorld.y + state.mapImage.naturalHeight
    }

    state.cursorWorld = world

    const inside = world.x >= aabb.left && world.x <= aabb.right && world.y >= aabb.top && world.y <= aabb.bottom

    if (!inside) return

    if (!state.startPoint || state.addSensorMode) {
      state.startPoint = world
    } else {
      state.segments.push({ a: state.startPoint, b: world })
      state.startPoint = null
    }

    historyTool.add()
    Renderer.render()
  }

  onPointerMove (e) {
    if (!state.pointDistanceMode) return

    const rect = viewport.canvas.getBoundingClientRect()
    const world = screenCssToWorld({ x: e.clientX - rect.left, y: e.clientY - rect.top })

    const aabb = {
      left: state.mapWorld.x,
      top: state.mapWorld.y,
      right: state.mapWorld.x + state.mapImage.naturalWidth,
      bottom: state.mapWorld.y + state.mapImage.naturalHeight
    }

    const inside = world.x >= aabb.left && world.x <= aabb.right && world.y >= aabb.top && world.y <= aabb.bottom

    if (inside) state.cursorWorld = world
    Renderer.render()
  }

  toggleVisibility () {
    this.element.classList.toggle('hidden', !state.calibration)
  }

  onEscape () {
    state.segments = []
    state.startpoint = null
    historyTool.add()
    Renderer.render()
  }

  onBackspace () {
    if (state.startPoint) state.startPoint = null
    else if (state.segments.length != 0) state.segments.pop()
    historyTool.add()
    Renderer.render()
  }
}

export let pointDistanceTool = null

export function initPointDistanceTool () {
  pointDistanceTool = new PointDistanceTool()
  return pointDistanceTool
}
